<template>
	<section>
		
    <v-text-field
    label="Teléfono"
    prepend-icon="mdi-phone"
    v-model="datosContacto.telefono"
    ></v-text-field>          
    <v-text-field
    label="Correo electrónico"
    prepend-icon="mdi-email"
    v-model="datosContacto.email"
    ></v-text-field>
    <v-text-field
    label="Sitio web"
    prepend-icon="mdi-web"
    v-model="datosContacto.web"
    ></v-text-field>          
    <v-text-field
    label="Youtube"
    prepend-icon="mdi-youtube"
    v-model="datosContacto.youtube"
    ></v-text-field>
    <v-text-field
    label="GitHub"
    prepend-icon="mdi-github"
    v-model="datosContacto.github"
    ></v-text-field>
    <v-btn
    block
    dark
    color="indigo darken-4"
    elevation="2"
    @click="registrar"
    > Establer datos contacto
    </v-btn>
  </section>
</template>
<script>
	export default{
		name: "DatosContacto",

    data:()=>({
      datosContacto: {
        telefono: "",
        email: "",
        web: "",
        youtube: "",
        github: ""
      }
    }),

    methods: {
      registrar(){
        this.$emit("contacto", this.datosContacto)
      }
    }
  }
</script>